/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlEvidence {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlEvidence.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlEvidence>): ComplianceAssessmentControlEvidence {
        let obj = Object.assign(new ComplianceAssessmentControlEvidence(), model);
        ComplianceAssessmentControlEvidence.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlEvidence>): ComplianceAssessmentControlEvidence {
        if (!model) return null;
        return ComplianceAssessmentControlEvidence.newInstance(<ComplianceAssessmentControlEvidence> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlEvidence) {
        if (!obj) return;

        models.ComplianceAssessmentControlEvidence.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlEvidence): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlEvidence.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
    }

    /**
     * Comment or notes regarding the control assessment response
     */
    comment: string;

    attachment_ids: Array<string>;

    /**
     * Timestamp when the control answer was recorded
     */
    created_at: Date;

    /**
     * Name of user who provided evidence
     */
    created_by: string;

}
